export const aspNetPageData = {
  hero: {
    heading: "ASP NET Development\nServices",
    subtext:
      "When your roadmap moves quickly, your .NET platform needs fast releases, stable integrations, and security. Quokka Labs provides ASP.NET development services for maintainable web apps and APIs, plus modernization, performance tuning, enterprise-grade security, seamless integrations, and scalable infrastructure. ",
    buttonText: "Talk to an Expert",
    link: "https://quokkalabs.com/contact-us",
  },

  awardsSection: {
    title: "Award-Winning Asp Net Development Services",
  },

  services: {
    heading: "ASP Net Development Services We Offer",
    intro:
      "Need a .NET partner that can build fast without creating future tech debt? Quokka Labs delivers end-to-end ASP .NET development services - from new product builds to modernization and long-term support - engineered for real-world scale, secure access control, and smooth integrations. Every service below is designed to keep your application stable today and adaptable for what's next.",

    items: [
      {
        title: "Enterprise ASP .NET Development",
        desc: "We build enterprise platforms with clean architecture, role-based access, audit trails, and observability. Designed for high-traffic operations, complex workflows, and regulated environments where reliability and governance matter.",
      },
      {
        title: "ASP .NET Web Application Development",
        desc: "We develop full-featured web apps with secure authentication, responsive UI integration, and API-first backends. Ideal for portals, dashboards, and business systems that must evolve quickly.",
      },
      {
        title: "ASP .NET Core API & Microservices Development",
        desc: "As an asp net core development company, we deliver fast, scalable APIs and microservices. Built for containers, cloud deployment, and stable integrations across products, teams, and environments.",
      },
      {
        title: "Legacy .NET Modernization & Migration",
        desc: "We modernize legacy ASP .NET applications by upgrading frameworks, refactoring risky modules, improving performance, and migrating to .NET Core incrementally—minimizing downtime while protecting business continuity.",
      },
      {
        title: "ASP .NET Consulting",
        desc: "We assess your codebase, performance bottlenecks, security gaps, and integration needs. Then we define a practical roadmap—architecture decisions, delivery plan, and measurable improvements.",
      },
      {
        title: "ASP .NET Maintenance, Support & Optimization",
        desc: "We keep production systems healthy with monitoring, incident support, security patches, dependency upgrades, and performance tuning. You get stability, predictable releases, and continuous improvement without churn.",
      },
    ],
  },

  trutStats: {
    heading: "Our ASP Net Development Services Proven Results",
    items: [
      {
        value: "12+",
        label: "Years of Experience",
      },
      {
        value: "200+",
        label: "Projects Delivered",
      },
      {
        value: "60+",
        label: "Digital products designed and developed",
      },
      {
        value: "40%",
        label: "Faster delivery using AI engineering accelerators",
      },
    ],
  },

  mainServices: {
    heading: "Our Services",
    intro:
      "Our services combine scalable engineering, security-first practices, and modern delivery workflows to help teams build dependable digital products. We support end-to-end execution - strategy to build to optimization - so your applications can handle real users, real data, and real business complexity.",

    categories: [
      {
        title: "AI Development Services",
        items: [
          {
            title: "AI Consulting",
            desc: "We help you choose the right AI use cases based on impact, feasibility, and risk—then outline a clear plan for implementation, measurement, and adoption across teams and systems.",
            link: "./ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-phone.svg",
          },
          {
            title: "Generative AI Consulting",
            desc: "We assess where generative AI fits naturally—support, documentation, search, reporting, and productivity—and define a practical path from prototype to secure production deployment.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-image.svg",
          },
          {
            title: "AI Agent Development",
            desc: "We build AI agents that complete multi-step tasks like triage, routing, follow-ups, and data handling—integrated with your tools and applications using safe workflows and permissions.",
            link: "./agentic-ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-programming.svg",
          },
          {
            title: "AI-Powered Product Development",
            desc: "We design products where intelligence is part of the core experience—recommendations, personalization, predictions, and decision support—built to stay accurate and maintainable over time.",
            link: "./ai-native-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-voice.svg",
          },
          {
            title: "AI Security & Governance",
            desc: "We add safeguards for AI systems—monitoring, access controls, evaluation practices, and policy enforcement—especially for regulated data, sensitive workflows, and high-scale usage.",
            link: "./ai-security-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-security.svg",
          },
          {
            title: "Generative AI Solution Development",
            desc: "We build LLM-based solutions for assistants, internal chat tools, content workflows, insights generation, and reporting—focused on reliability, performance, and responsible deployment.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-computer.svg",
          },
          {
            title: "AI Feature Engineering",
            desc: "We deliver production AI features end-to-end—data prep, model selection, API integration, and UI delivery—so teams can ship real outcomes instead of demos.",
            link: "./ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-innovation.svg",
          },
          {
            title: "Machine Learning Development",
            desc: "We develop and deploy ML models for forecasting, anomaly detection, classification, and optimization—supporting both real-time and batch workflows with clear evaluation metrics.",
            link: "./ml-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-setting.svg",
          },
          {
            title: "AI/ML Systems Development",
            desc: "We combine AI and ML into complete systems—pipelines, models, services, and monitoring—so automation stays transparent, scalable, and dependable in day-to-day operations.",
            link: "./artificial-intelligence-machine-learning-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-brain.svg",
          },
        ],
      },

      {
        title: "App Development Services",
        items: [
          {
            title: "Mobile Application Development",
            desc: "We build secure mobile apps that connect cleanly with your backend—supporting workflows, reporting, messaging, and collaboration with strong performance and stability.",
            link: "./mobile-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame.svg",
          },
          {
            title: "Web Application Development",
            desc: "We design and modernize web applications with clean architecture, modular components, and secure APIs—so platforms stay fast, scalable, and easier to evolve.",
            link: "./web-application-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/web-design.svg",
          },
          {
            title: "Data & Analytics",
            desc: "We turn raw data into dashboards, reporting layers, and analytics systems—helping teams track performance, identify patterns, and make decisions with confidence.",
            link: "./data-analytics-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-recovery.svg",
          },
          {
            title: "Blockchain Development",
            desc: "We implement blockchain where it adds real value—tamper-resistant logs, verification flows, and multi-party records—designed for compliance and traceability needs.",
            link: "./blockchain-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame2.svg",
          },
          {
            title: "iOS Application Development",
            desc: "We build iOS apps optimized for speed, reliability, and long-term maintainability—integrated with backend services and designed for stable releases.",
            link: "./ios-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fra3.svg",
          },
          {
            title: "UI/UX Design",
            desc: "We create interfaces that reduce friction and improve usability—clear navigation, accessible design, and consistent interaction patterns across complex products.",
            link: "./ui-ux-design-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fram4.svg",
          },
          {
            title: "DevOps Services",
            desc: "We implement CI/CD, infrastructure automation, monitoring, and deployment best practices—improving release speed, stability, and system availability.",
            link: "./devops-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/wireless-cloud.svg",
          },
          {
            title: "Quality Assurance Engineering",
            desc: "We validate functionality, integrations, performance, and security through structured testing—reducing regressions and improving production confidence.",
            link: "./quality-analyst",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-check.svg",
          },
          {
            title: "AR/VR Development",
            desc: "We build AR/VR experiences for training, visualization, simulation, and product demonstrations—focused on usability and real-world outcomes, not just novelty.",
            link: "./ar-vr-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/vr-stroke-rounded.svg",
          },
        ],
      },

      {
        title: "Staff Augmentation",
        items: [
          {
            title: "Android Developers",
            desc: "Add Android engineers who can ship production-ready apps with clean architecture, API integrations, and strong release discipline.",
            link: "./hire-android-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "iOS Developers",
            desc: "Scale iOS delivery with specialists who build stable, high-performance apps aligned with your quality and security standards.",
            link: "./hire-ios-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/appstore.svg",
          },
          {
            title: "Flutter Developers",
            desc: "Accelerate cross-platform development with Flutter developers focused on maintainable shared code, consistent UI, and scalable app structure.",
            link: "./hire-flutter-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-developer.svg",
          },
          {
            title: "React Native Developers",
            desc: "Extend your roadmap with React Native engineers who deliver consistent experiences across platforms while keeping maintenance and iteration efficient.",
            link: "./hire-react-native-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/react-stroke.svg",
          },
          {
            title: "Python Developers",
            desc: "Bring in Python developers for backend services, automation, analytics, integrations, and data-heavy systems that require clean, dependable architecture.",
            link: "./hire-python-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/python.svg",
          },
          {
            title: ".NET Developers",
            desc: "Work with .NET engineers to build secure web applications, APIs, and enterprise platforms with integration readiness and long-term maintainability.",
            link: "./hire-dotnet-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/server-stack.svg",
          },
          {
            title: "Node.js Developers",
            desc: "Add Node.js developers for real-time features, event-driven services, and high-concurrency workloads with strong performance and reliability practices.",
            link: "./hire-node-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/3rd-bracket.svg",
          },
          {
            title: "React JS Developers",
            desc: "Strengthen frontend execution with React developers building modular interfaces, design systems, and fast user experiences connected to scalable APIs.",
            link: "./hire-react-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "Firebase Developers",
            desc: "Hire Firebase experts to implement authentication, real-time databases, storage, analytics, and serverless workflows that speed up development and iteration.",
            link: "./hire-firebase-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/fire-stroke.svg",
          },
        ],
      },
    ],
  },

  newsLetter: {
    heading: "Ready to Modernize and Scale Your ASP .NET Platform with Confidence?",
    desc: "From customer portals and SaaS products to enterprise workflow systems and data-driven dashboards, we help teams ship secure, high-performing ASP .NET solutions built for reliability, scalability, and long-term maintainability.",
    buttonText: "Get Started",
    link: "https://quokkalabs.com/contact-us",
  },

  caseStudies: {
    heading: "Our ASP Net Development Services Proven Results",

    items: [
      {
        title: "SHL",
        desc: "SHL is a mobile-enabled enterprise platform used for large-scale talent assessments, analytics, and workforce insights. Quokka Labs supported platform delivery with ASP .NET development services focused on performance under load, multi-role access control, and stability across global usage.",
        results: [
          "50% Increase in Assessment Throughput",
          "30% Improvement in Platform Adoption",
        ],
        url: "./shl",
        color: "#DDEEFF",
        image:"https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/shl.webp",
      },
      {
        title: "Learnloft",
        desc: "Learnloft is an enterprise learning platform built to manage training at scale, covering course delivery, learner tracking, assessments, and reporting. Quokka Labs delivered ASP .NET web development with secure role-based access, structured content workflows, and analytics-ready reporting.",
        results: [
          "80% Improvement in Learner Engagement",
          "45% Faster Course Deployment Cycles",
        ],
        url: "./learnloft",
        color: "#C6DFFF",
        image:"https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/learnloft.webp",
      },
    ],
  },

  keyFeatures: {
    heading: "Key Features We Integrate into ASP .NET Applications",

    items: [
      {
        title: "Performance Optimization & Caching for High-Traffic Systems",
        desc: "Fast experiences require more than good hosting. We tune ASP .NET applications to stay responsive under load—improving database efficiency, reducing latency, and stabilizing performance during traffic spikes.",
        points: [
          "Query optimization, indexing strategy, and efficient data access patterns",
          "In-memory and distributed caching (e.g., Redis) for hot paths",
          "Async-first request pipelines to improve throughput",
          "Rate limiting, backpressure, and resilience patterns",
          "Load testing and performance baselining for predictable scaling",
          "CDN and asset optimization for faster page delivery",
        ],
      },
      {
        title: "Identity, Security Hardening & Audit Controls",
        desc: "Security can't be bolted on after launch—especially for enterprise platforms. We integrate strong identity controls and governance in ASP .NET systems to protect data, enforce policy, and support compliance requirements.",
        points: [
          "SSO integrations (Azure AD, Okta) with OAuth2/OIDC",
          "Fine-grained authorization for users, roles, and resources",
          "Secure secrets management and environment isolation",
          "OWASP-aligned hardening and vulnerability remediation",
          "Audit logs for access, changes, and sensitive actions",
          "Data protection strategies for regulated or high-risk workflows",
        ],
      },
      {
        title: "Observability, Monitoring & Production Readiness",
        desc: "Teams move faster when systems are measurable and debuggable. We add observability layers so you can detect issues early, trace failures, and maintain uptime with confidence.",
        points: [
          "Structured logging with correlation IDs across services",
          "Metrics and dashboards for latency, errors, and throughput",
          "Distributed tracing for debugging complex workflows",
          "Alerting rules tied to real operational thresholds",
          "Incident-friendly runbooks and production checks",
          "Release confidence through staged rollouts and monitoring gates",
        ],
      },
      {
        title: "Cloud-Native Deployment & DevOps Automation",
        desc: "Reliable delivery depends on repeatable deployment. We implement cloud-ready infrastructure and DevOps workflows so ASP .NET applications ship faster, roll back safely, and scale across environments.",
        points: [
          "CI/CD pipelines with automated testing and gated releases",
          "Containerization with Docker and orchestration readiness",
          "Infrastructure-as-code patterns for consistency across environments",
          "Blue-green / canary deployments to reduce release risk",
          "Secure configuration management and secrets rotation",
          "Cost-aware scaling strategies for predictable operations",
        ],
      },
    ],
  },

  capabilities: {
    heading: "What You Get with Our ASP Net Development Services Expertise",
    subtext:
      "Our approach is built around what matters most in modern .NET delivery: clear architecture, production performance, and long-term maintainability. Every solution we build balances delivery speed with system stability, integrations with governance, and flexibility with security, so your application can grow without constant rework as users, data, and workflows scale.",

    items: [
      {
        title: "Cloud-Native Delivery & DevOps Readiness",
        desc: "We ship ASP .NET solutions with CI/CD pipelines, container-friendly builds, environment parity, and safe rollout strategies—so releases stay predictable across staging and production.",
      },
      {
        title: "Legacy Modernization Without Big-Bang Risk",
        desc: "We modernize older .NET applications incrementally—upgrading frameworks, refactoring high-risk modules, and improving security/performance—so you move forward without long downtime or rewrites.",
      },
      {
        title: "Multi-Tenant SaaS Engineering",
        desc: "We design SaaS-ready .NET platforms with tenant isolation, subscription controls, configurable feature flags, and scalable data patterns—built to support growth across customers and regions.",
      },
      {
        title: "Data Layer Excellence & Reliability",
        desc: "We build fast, dependable data layers—optimized queries, indexing, caching, and transactional consistency—so your application remains stable even with heavy reads, writes, and reporting demands.",
      },
      {
        title: "Test Automation & Release Confidence",
        desc: "We add automated tests and quality gates that protect every release—unit, integration, and API validations—reducing regressions and keeping velocity high as the codebase expands.",
      },
      {
        title: "Security-by-Design Engineering Culture",
        desc: "We bake security into delivery—secure coding practices, dependency hygiene, secrets management, least-privilege access, and continuous monitoring—so your ASP .NET platform stays resilient over time.",
      },
    ],
  },

  ourProcess: {
    heading: "Our End-To-End ASP Net Development Services Delivery Process for Modern App",

    subtext:
      "A structured, engineering-led delivery approach that converts complex requirements into secure, scalable ASP .NET systems. From product planning and UX to .NET architecture, development, testing, and release operations, our process keeps execution predictable while safeguarding long-term performance, stability, and business outcomes.",

    steps: [
      {
        number: "01",
        title: "Discovery & ASP .NET Roadmap",
        desc: "We begin by clarifying business goals, user roles, workflows, compliance needs, and the systems your application must connect with. Then we define core domains, service boundaries, and a delivery plan that reduces risk and prevents costly redesigns later.",
      },
      {
        number: "02",
        title: "UX & Workflow Design for Real-World Use",
        desc: "We design interfaces for speed, clarity, and everyday operational efficiency—especially in multi-role products. Wireframes and prototypes focus on key tasks, dashboards, decision paths, and friction reduction so complex workflows still feel intuitive.",
      },
      {
        number: "03",
        title: ".NET Architecture, Data Strategy & Security Foundation",
        desc: "We choose the right application structure—monolith, modular monolith, microservices, or hybrid—based on scale, team size, and release cadence. This includes API standards, database strategy, caching, identity and access control, observability, and cloud deployment planning.",
      },
      {
        number: "04",
        title: "Iterative ASP .NET Development & Integration Sprints",
        desc: "We build in disciplined sprints across APIs, services, UI layers, and integrations. Delivery includes business logic implementation, role-based permissions, workflow orchestration, and integrations with ERP/CRM systems and third-party tools—shipping usable increments continuously.",
      },
      {
        number: "05",
        title: "Testing, Performance Engineering & Hardening",
        desc: "We go beyond basic QA. Validation covers business rules, edge cases, data integrity, and integration stability. Performance work includes profiling, load testing, concurrency checks, and security hardening—authentication flows, vulnerability testing, and audit logging.",
      },
      {
        number: "06",
        title: "Deployment, Release Readiness & Production Observability",
        desc: "We set up CI/CD pipelines, environment consistency, monitoring, logging, alerting, and rollback strategies. Production readiness includes deployment automation, configuration management, and runtime visibility—so releases are confident and troubleshooting is faster.",
      },
      {
        number: "07",
        title: "Post-Launch Scaling, Optimization & Continuous Evolution",
        desc: "After launch, we improve throughput, reduce latency, and expand functionality safely as usage grows. Whether modernizing legacy modules or scaling new services, we keep your ASP .NET platform maintainable through continuous refinement and improvement.",
      },
    ],
  },

  compliance: {
    heading: "Built to Meet Enterprise-Grade ASP .NET Compliance Standards",

    intro:
      "Compliance shouldn't be a last-minute checklist, it should be built into how your product is engineered. With our ASP .NET development services, Quokka Labs aligns architecture, security, and delivery workflows with modern privacy requirements, cybersecurity controls, IP protection, and operational governance. Whether you're building .NET systems for internal operations, customer portals, SaaS platforms, or multi-tenant web applications, we design for audit readiness, data protection, and long-term regulatory confidence.",

    sections: [
      {
        title: "Application Security & Threat Protection",
        desc: "We implement secure ASP .NET application patterns with strong encryption, hardened API layers, secure authentication/authorization, automated security scanning, and continuous monitoring. From dependency management to runtime safeguards, we reduce risk across development, deployment, and ongoing operations.",
      },
      {
        title: "Data Privacy & Information Governance",
        desc: "We protect sensitive data using least-privilege access, encryption in transit and at rest, audit logging, and environment-aware configurations. We also help teams set up governance controls that support traceability, access accountability, and privacy expectations across distributed systems.",
      },
      {
        title: "Operational Resilience & Risk Management",
        desc: "We engineer ASP .NET platforms to remain dependable under real-world stress—structured logging, incident readiness, disaster recovery planning, and high-availability infrastructure. Delivery includes backup strategies, failover patterns, and reliability practices to support continuity during spikes, outages, or security events.",
      },
    ],

    standards: [
      "GDPR – Data privacy and protection regulation",
      "CCPA – Consumer data privacy requirements",
      "SOC 2 – Security and operational controls",
      "ISO/IEC 27001 – Information security management",
      "OWASP – Secure application best practices",
      "PCI-DSS – Payment data security requirements",
    ],
  },

  industries: {
    heading: "We Power Enterprise-Grade ASP .NET Transformation Across Key Industries",

    subtext:
      "Our ASP .NET development services help organizations operating in high-scale, security-sensitive, and compliance-driven environments. As an asp net web development company, we build reliable .NET platforms that modernize operations, connect systems, and support long-term digital transformation across regulated and fast-growing industries.",

    items: [
      {
        title: "Healthcare",
        points: [
          "Secure ASP .NET solutions for patient portals, scheduling, telehealth coordination, and care workflows",
          "Integration-ready services for EHR/EMR connectivity, reporting, and operational visibility",
          "Role-based access for clinicians, staff, and administrators with audit logging",
          "Protected data handling and compliance-aligned architecture for sensitive healthcare systems",
        ],
      },
      {
        title: "Manufacturing",
        points: [
          "ASP .NET platforms for production tracking, plant coordination, and supply chain visibility",
          "Real-time dashboards for inventory, procurement, logistics, and equipment status",
          "ERP-connected systems for multi-site planning, approvals, and execution workflows",
          "Automation-driven processes that reduce manual effort and improve consistency",
        ],
      },
      {
        title: "Education",
        points: [
          "Scalable ASP .NET web platforms for LMS, training operations, and student management",
          "Secure portals for admissions, assessments, content workflows, and progress tracking",
          "Multi-role experiences for learners, faculty, and administrators with structured permissions",
          "Analytics and reporting dashboards that improve decision-making and program outcomes",
        ],
      },
      {
        title: "Real Estate",
        points: [
          "ASP .NET solutions for property management, transactions, and portfolio operations",
          "CRM-integrated systems for brokers, agencies, and customer coordination",
          "Secure document workflows with e-signatures, approvals, versioning, and permissions",
          "High-performance portals for listings, tenant requests, and deal pipelines",
        ],
      },
      {
        title: "FinTech",
        points: [
          "Secure ASP .NET applications for payments, lending workflows, and wealth platforms",
          "Compliance-ready architecture with KYC/AML support, audit trails, and detailed logging",
          "High-availability systems designed for transaction-heavy performance and uptime",
          "API-first integrations with banking partners, identity providers, and financial services",
        ],
      },
      {
        title: "Retail",
        points: [
          "ASP .NET commerce and operations platforms for omnichannel and multi-location businesses",
          "Inventory, order, returns, and fulfillment systems engineered for speed and accuracy",
          "CRM-integrated customer portals, loyalty workflows, and personalization features",
          "Performance-optimized applications built to handle peak traffic and seasonal spikes",
        ],
      },
    ],
  },

  techStack: {
    heading: "Our Tech Stack",
    intro:
      "We use a modern, enterprise-ready tech stack engineered to support secure, scalable, and high-performance ASP .NET development services.",

    categories: [
      {
        title: "Frontend",
        items: ["HTML5", "CSS3", "Tailwind CSS", "JavaScript", "React.js"],
      },
      {
        title: "Mobile",
        items: ["iOS (Swift)", "Android (Kotlin)", "Flutter", "React Native"],
      },
      {
        title: "Backend",
        items: ["ASP .NET Core", ".NET", "Node.js", "Python", "Java"],
      },
      {
        title: "Database",
        items: ["MongoDB", "PostgreSQL", "MySQL", "Firebase"],
      },
      {
        title: "Cloud & DevOps",
        items: ["AWS", "Azure", "Google Cloud", "Docker", "CI/CD Pipelines"],
      },
      {
        title: "AI & Analytics",
        items: [
          "Machine Learning",
          "Generative AI",
          "Data Analytics",
          "TensorFlow",
        ],
      },
    ],
  },

  newsLetter2: {
    heading: "Reduce ASP .NET Platform Costs and Improve Performance with Smarter Architecture",

    subtext:
      "Whether you're launching a new ASP .NET web application, modernizing legacy .NET systems, or scaling high-throughput APIs, we help you streamline architecture, infrastructure, and data layers for efficiency. Ship faster with cleaner service design, improve runtime speed and reliability, scale predictably under real traffic, and lower operational overhead across your ASP .NET applications.",

    buttonText: "Book a Call",
    link: "https://quokkalabs.com/contact-us",
  },

  ai_Focused: {
    heading: "AI-Driven Intelligence for Modern ASP .NET Applications",

    subtext:
      "We integrate AI, machine learning, and analytics into ASP .NET platforms to help teams automate routine work, surface better insights, and deliver smarter product experiences. From prediction layers and intelligent reporting to assistant-led workflows and personalization, our AI-enabled .NET engineering helps applications adapt in real time, reduce manual effort, and drive measurable outcomes—without compromising security or performance.",

    items: [
      "AI Consulting for .NET Product Strategy",
      "Predictive Analytics & Decision Intelligence",
      "AI-Led Modernization for Legacy .NET Systems",
      "Workflow Automation & AI Assistants",
      "Fraud Detection, Risk Scoring & Security Monitoring",
      "AI-Driven Optimization & Automated Decisioning",
    ],
  },

  whyChoose: {
    heading: "Why Quokka Labs is Your ASP.NET Advantage for Secure, High-Scale Product Delivery",

    subtext:
      "Building on ASP.NET isn't just about shipping endpoints, it's about delivering a platform that stays reliable as users, data, and integrations grow. As an ASP NET web development company that works like a product engineering partner, Quokka Labs focuses on clean architecture, security-by-design, and delivery practices that keep your application maintainable long after launch.",

    items: [
      {
        number: "01",
        title: "Product-Led ASP.NET Engineering",
        desc: "We don't treat development like a checklist. We align features to core user journeys, operational realities, and business goals—so your ASP.NET solution supports adoption, retention, and measurable ROI.",
      },
      {
        number: "02",
        title: "Transparent Execution with Sprint-Level Control",
        desc: "Complex builds fail when scope gets fuzzy. Our delivery model keeps planning, sprints, demos, QA, and releases highly visible—so progress is trackable and decisions stay aligned across stakeholders.",
      },
      {
        number: "03",
        title: "Performance-Driven Architecture on .NET",
        desc: "We architect for speed and stability from day one—clear boundaries, efficient data access, caching where it matters, and observability baked in. Your system stays responsive as load and usage patterns evolve.",
      },
      {
        number: "04",
        title: "Automation That Proves Its Value",
        desc: "We add automation only when it improves outcomes—streamlining approvals, reducing manual effort, enhancing reporting, or improving support workflows—so smart features stay practical, measurable, and maintainable.",
      },
      {
        number: "05",
        title: "Communication That Keeps Projects Moving",
        desc: "You get clear ownership, consistent updates, and direct access to the people building your product. We integrate into your tools and rituals to keep velocity high and blockers short-lived.",
      },
      {
        number: "06",
        title: "Built for Enterprise Reality",
        desc: "As an ASP NET Core development company experienced with complex environments, we handle real-world constraints—SSO, RBAC, audit trails, compliance needs, legacy modernization, and multi-system integrations—without forcing disruptive rewrites.",
      },
    ],
  },

  hireCTATeamBanner: {
    heading: "Hire Enterprise-Grade Developers Around You!",

    subtext:
      "Engaging with our engineers accelerates your roadmap and strengthens compliance.",

    buttonText: "Hire Developer",
    link: "https://quokkalabs.com/contact-us",
  },

  nextGenTech: {
    heading: "Future-Proof Innovations That Power High-Performing ASP.NET Applications",

    subtext:
      "We don't treat modern capabilities as add-ons. Our engineers design them into your ASP.NET foundation, so your platform stays secure, scalable, and ready for enterprise-grade complexity. From cloud-native .NET architectures to intelligent automation, we build systems that handle heavy workloads, deep integrations, and fast-changing roadmaps without losing stability.",

    items: [
      {
        title: "Cloud",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/cloud-new-new.webp",
        desc: "We design cloud-ready ASP.NET architectures built for uptime and scale—containerized deployments, autoscaling services, and resilient runtime patterns. Whether you're on Azure, AWS, or a hybrid setup, we optimize performance, cost, and release predictability across environments.",
      },
      {
        title: "Blockchain",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/block-chain-new.webp",
        desc: "When traceability matters, we connect blockchain-backed verification to ASP.NET workflows—supporting tamper-resistant records, auditable activity trails, and multi-party validation. Ideal for compliance-heavy processes that need integrity without slowing operations.",
      },
      {
        title: "IoT",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/iot-new-new.webp",
        desc: "We connect devices and sensor networks to ASP.NET backends to enable real-time monitoring, event alerts, and operational dashboards. This creates always-on visibility for logistics, manufacturing, healthcare, and facilities—built for reliable ingestion and actionable insights.",
      },
      {
        title: "Data Science & Analytics",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-engi-new.webp",
        desc: "We turn raw operational data into usable intelligence by building analytics layers, reporting dashboards, and forecasting models that integrate cleanly with ASP.NET services. Teams get real-time clarity across usage, performance, risk, and growth metrics.",
      },
      {
        title: "Robotic Process Automation (RPA)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/robotic-new.webp",
        desc: "We reduce manual effort by integrating RPA with ASP.NET applications and APIs—automating tasks like approvals, reconciliations, form processing, and reporting. The outcome is faster execution, fewer errors, and smoother workflows across departments.",
      },
      {
        title: "Generative AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/gen-ai-new.webp",
        desc: "We embed generative AI into ASP.NET products to improve productivity—knowledge search, internal assistants, automated documentation, and content workflows. Implemented with governance, access controls, and measurable outcomes so AI stays safe and useful.",
      },
      {
        title: "Machine Learning (ML)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ml-ne.webp",
        desc: "We deploy ML capabilities that enhance ASP.NET platforms with prediction, personalization, anomaly detection, and optimization. Your application becomes smarter over time—adapting to changing data patterns and user behavior at scale.",
      },
      {
        title: "Agentic AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/agentic-ai-new.webp",
        desc: "We build agentic AI systems that plan and execute multi-step workflows across tools and services—routing tasks, triggering actions, handling exceptions, and escalating approvals. The result: lower operational load and faster process completion across teams.",
      },
    ],
  },

  blogs: {
    heading: "What's New in ASP NET Development?",
  },

  faqs: {
    heading: "FAQs: ASP NET Development Services",

    items: [
      {
        question: "What are ASP .NET development services, and what do they typically include?",
        answer:
          "ASP .NET development services cover the end-to-end engineering required to build, modernize, and maintain web applications, APIs, and enterprise platforms using Microsoft's .NET ecosystem (commonly ASP .NET Core for modern builds). For most businesses, it's not only 'writing code'—it includes architecture decisions, security, integrations, testing, and deployment discipline that keeps the product stable as it grows.",
        points: [
          "Product discovery and technical planning (requirements, roadmap alignment, technical risks)",
          "Architecture and system design (modular monolith vs microservices, API strategy, data modeling)",
          "ASP .NET web application development (portals, dashboards, internal systems, SaaS apps)",
          "API development and integration (REST/GraphQL, third-party tools, CRM/ERP connections)",
          "Security implementation (SSO, OAuth/OIDC, RBAC, audit logging, secure data handling)",
          "Quality assurance (unit/integration testing, automation, performance validation)",
          "DevOps and release engineering (CI/CD pipelines, monitoring, environment management)",
          "Maintenance and optimization (bug fixes, upgrades, performance tuning, incident response)",
        ],
      },
      {
        question: "How do I choose the right ASP NET web development company for my project?",
        answer:
          "Choosing an ASP NET web development company is really about reducing risk—technical risk, security risk, and delivery risk. Beyond portfolios, ask how the team handles architecture, testing, and maintainability. A solid partner should help you build a platform that won't collapse under future requirements.",
        points: [
          "Architecture approach: Do they discuss modular architecture, domain boundaries, and scalability tradeoffs?",
          "Security maturity: Can they implement SSO, RBAC, audit trails, and secure API patterns?",
          "Integration readiness: Have they handled payments, CRM/ERP, identity providers, and third-party APIs?",
          "Engineering quality: Code reviews, testing standards, documentation, and release discipline",
          "Operational readiness: Monitoring, logs, alerting, and incident workflows",
          "Communication: Clear ownership, predictable updates, and transparent delivery milestones",
        ],
      },
      {
        question: "What's the difference between ASP .NET and ASP .NET Core and which should I use?",
        answer:
          "ASP .NET Core is the modern, cross-platform framework designed for performance, cloud readiness, and long-term support. Legacy ASP .NET (often tied to older patterns and Windows-only deployments) still exists in many organizations, but new builds typically favor Core.",
        points: [
          "Choose ASP .NET Core for cloud-native deployments, container support, and improved performance",
          "Choose ASP .NET Core for modern development tooling and long-term maintainability",
          "Use legacy ASP .NET when maintaining an existing system and needing stability during transition",
          "A phased modernization strategy is often more realistic than a full rewrite for legacy systems",
        ],
      },
      {
        question: "How much does it cost to build an ASP .NET web application?",
        answer:
          "The web app cost depends on scope, complexity, integrations, and how production-ready you need the first release to be. An MVP portal is very different from a multi-tenant SaaS product with SSO, analytics, payments, and heavy integrations.",
        points: [
          "Feature complexity (workflows, permissions, reporting, automation)",
          "Integrations (CRM/ERP, payment gateways, identity providers, analytics tools)",
          "Data requirements (migrations, complex reporting, real-time data)",
          "Security and compliance needs (audit trails, encrypted data, regulated requirements)",
          "Scale expectations (high traffic, multi-region availability, performance SLAs)",
        ],
      },
      {
        question: "How long does ASP .NET application development take?",
        answer:
          "Timeline depends on the product stage and complexity, but most teams ship faster when they start with clear architecture and a realistic scope for the first release. A typical .NET build is often delivered in milestones: discovery, foundation, core features, integrations, hardening, and launch.",
        points: [
          "Number of user roles and workflow steps",
          "Integration and data migration scope",
          "UI complexity (custom design systems vs simpler components)",
          "Testing depth (automation, performance testing, security hardening)",
          "Release readiness (CI/CD, monitoring, documentation, environment setup)",
        ],
      },
      {
        question: "Can you modernize a legacy .NET application without a full rewrite?",
        answer:
          "Yes—and in most cases, you should avoid a risky 'big bang rewrite.' The best asp net application development services teams use incremental modernization: upgrade what matters first, reduce risk, and keep the business running.",
        points: [
          "Upgrade framework versions in stages to reduce security and dependency risk",
          "Extract APIs from legacy modules to enable new UI and integrations",
          "Refactor high-risk areas (authentication, data access, performance bottlenecks)",
          "Move to ASP .NET Core iteratively, module by module",
          "Improve observability (logs/metrics/traces) so issues are visible and fixable",
        ],
      },
      {
        question: "What security best practices should an ASP .NET development team implement?",
        answer:
          "Security is a core reason many companies choose .NET. But strong security isn't automatic—it's built through consistent patterns and governance-ready decisions.",
        points: [
          "Authentication and SSO (OAuth2/OIDC, Azure AD, Okta, etc.)",
          "Authorization with role-based access control (RBAC) and least-privilege permissions",
          "Secure API design: input validation, rate limiting, and idempotency for critical actions",
          "Audit logging for sensitive actions and permission changes",
          "Secrets management (no hardcoded keys, proper vault usage)",
          "OWASP-aligned safeguards and dependency vulnerability monitoring",
        ],
      },
      {
        question: "What types of products are best suited for ASP .NET development services?",
        answer:
          "ASP .NET is a strong choice when you need stability, security, performance, and long-term maintainability, especially for business-critical systems.",
        points: [
          "Enterprise portals (vendors, partners, internal teams)",
          "Workflow platforms (approvals, cases, audits, multi-step operations)",
          "SaaS applications (multi-tenant products with billing and role management)",
          "API-first platforms (mobile backends, third-party integrations, data services)",
          "Data-heavy dashboards (reporting, analytics, operational visibility)",
          "Regulated systems (governance, audit trails, strict access control)",
        ],
      },
      {
        question: "When should I outsource ASP NET development, and how do I do it safely?",
        answer:
          "Companies usually outsource ASP NET development when they need speed, specialized expertise, or additional capacity without long hiring cycles. It works best when outsourcing is structured around ownership and outcomes—not just extra hands.",
        points: [
          "Define success metrics and release milestones (not just hours)",
          "Require clear architecture documentation and decision logs",
          "Use coding standards, code review rules, and test expectations",
          "Ensure CI/CD and environments are set up early",
          "Clarify security responsibilities (SSO, permissions, audit, data handling)",
          "Establish a predictable communication rhythm (weekly demos, sprint reviews)",
        ],
      },
      {
        question: "What deliverables should I expect from an ASP NET Core development company?",
        answer:
          "A professional asp net core development company should deliver more than features. You should receive a production-ready system foundation—one that supports future development without constant rewrites.",
        points: [
          "A well-structured codebase with modular architecture",
          "API documentation with consistent endpoint patterns",
          "Authentication and authorization implementation with access policies",
          "Automated test coverage (unit and integration where needed)",
          "CI/CD pipelines with repeatable deployments",
          "Monitoring and logging setup for production visibility",
          "Documentation for setup, environments, and operational workflows",
          "Performance and security considerations baked into core services",
        ],
      },
    ],
  },
};